import { useUpdate,  useRedirect} from 'ra-core';
import React, {cloneElement, useCallback} from 'react';
import {
   EmailField,
   required,
   sanitizeListRestProps,
   SaveButton,
   SelectInput,
   Show,
   SimpleForm,
   Tab,
   TabbedShowLayout,
   TextField,
   TextInput,
   Toolbar,
   TopToolbar
} from 'react-admin';
import {IListActionsProps} from '../../consts/interfaces/Interfaces';
import {Messages} from '../../consts/Messages';
import {USER} from '../../consts/Names';
import {Validators} from '../../consts/Validators';
import {WithProps} from '../utils/RecordWrappers';
import {INQUIRY} from '../../consts/Names';

const ListActions = (props: IListActionsProps, ...rest) => {
   const {className, filters, resource, showFilter, displayedFilters, filterValues} = props;
   return (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
         {filters &&
            cloneElement(filters, {
               resource,
               showFilter,
               displayedFilters,
               filterValues,
               context: 'button'
            })}
      </TopToolbar>
   );
};

ListActions.defaultProps = {
   selectedIds: [],
   onUnselectItems: () => null
};

const PostEditToolbar = (props) => (
   <Toolbar {...props}>
      <SaveWithUpdateButton submitOnEnter={false} redirect={`/${USER.SOURCE}/`} />
   </Toolbar>
);
const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

const SaveWithUpdateButton = (props) => {
   const [update] = useUpdate(INQUIRY.SOURCE, props.record.id); //можно использовать useCreate если нужно создать новую запись
   const redirectTo = useRedirect();
   const handleSave = useCallback(
      (values, redirect) => {
         update(
            {
               payload: {data: {id: values.id, title: 'message', text: values.Message}}
            },
            {
               onSuccess: ({data: newRecord}) => {
                  redirectTo(redirect);
               }
            }
         );
      },
      [update, redirectTo]
   );
   return <SaveButton {...props} onSave={handleSave} label="Send Message" />;

};

export const InquiryShow = (props) => {
   return (
      <Show title="User Details" {...props} actions={<ListActions />}>
         <WithProps
            callBackFunc={(record) => {
               return record;
            }}>
            {({record, ...props}) => (
               <TabbedShowLayout {...props} record={record}>
                  <Tab label="Contact" path="contact">
                     <EmailField source={INQUIRY.id} />
                     <TextField source={INQUIRY.title} />
                     <SimpleForm toolbar={<PostEditToolbar />}  redirect="list">
                        <SelectInput source="Type" choices={[{id: 'email', name: 'Email'}]} />
                        <TextInput multiline source="Message" validate={validateStock} />
                     </SimpleForm>
                  </Tab>
               </TabbedShowLayout>
            )}
         </WithProps>
      </Show>
   );
};
